import { Box, Grid, Stack, Typography } from '@mui/material';
import PortalModal from '../../common/PortalModal';
import { useState } from 'react';
import { getCodecsColumns } from './columns';
import PortalDataGridPro from '../../common/PortalDataGridPro';

export default function RemoveCodecsModal({
  isOpen,
  toggleModalOpen,
  id,
  onConfirm,
  course,
  codecs,
  isSmall = false,
}) {
  const [selectedCodecs, setSelectedCodecs] = useState([]);

  return (
    <PortalModal
      title={'Remove Codecs'}
      maxWidth="md"
      isOpen={isOpen}
      onClose={toggleModalOpen}
      isCloseable
      isFullScreen={isSmall}
      primaryButtonTitle="Remove"
      isPrimaryButtonDisabled={!selectedCodecs.length}
      onPrimaryClick={() => onConfirm(selectedCodecs)}
      secondaryButtonTitle="Cancel"
      onSecondaryClick={toggleModalOpen}
      id={`${id}__modal`}
    >
      <Grid
        container
        id={`${id}__grid_container`}
        direction="column"
        spacing={2}
        sx={{
          justifyContent: 'center',
        }}
      >
        <Grid item id={`${id}__grid_item_text`} xs={12} xl={3}>
          <Typography id={`${id}_text`} variant="small">
            {`Select the codecs to remove from the course ${course.SUBJECT_CODE} ${course.COURSE_NUMBER} - ${course.CRN} and its meetings.`}
          </Typography>
        </Grid>

        <Grid item id={`${id}__grid_item_codecs`} xs={12} xl={3}>
          <PortalDataGridPro
            id={`${id}__dataGrid`}
            className="myOdu__resultTable inner"
            rows={codecs}
            columns={getCodecsColumns(id, isSmall)}
            getRowId={(row) => row.uid}
            autoHeight
            checkboxSelection={true}
            onRowSelectionModelChange={setSelectedCodecs}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
            }}
            pagination
            getRowHeight={(params) => {
              return 'auto';
            }}
            disableRowSelectionOnClick
            slots={{
              noRowsOverlay: () => {
                return (
                  <Box
                    id={`${id}__box_noCodecsWrapper`}
                    mt={1}
                    display="flex"
                    justifyContent="center"
                  >
                    <Typography id={`${id}__text_noCodecs`} variant="p" component="p">
                      No codecs found.
                    </Typography>
                  </Box>
                );
              },
            }}
          />
        </Grid>
      </Grid>
    </PortalModal>
  );
}
